"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicFootnoteServiceV1Implementation = void 0;
const TextReplacmentUtility_1 = require("../utilities/TextReplacmentUtility");
const Extract_1 = require("../utilities/Extract");
const EmissionConsumption_1 = require("../utilities/EmissionConsumption");
const EqualFootnotes_1 = require("../utilities/EqualFootnotes");
const DynamicFootnoteServiceV1Implementation = (options, env) => {
    const footnoteService = env.featureServices['audi-footnote-service'];
    const marketContextService = env.featureServices['audi-market-context-service'];
    const localeService = env.featureServices['locale-service'];
    const i18Service = env.featureServices['dbad:audi-i18n-service'];
    const vueFormatterService = env.featureServices['dbad:audi-vue-formatter-service'];
    let resolvedEfficiencyLabelPromise;
    let lastFootnotesFromFefa = [];
    const getConfigData = () => {
        return new Promise((resolveConfigDataPromise) => {
            resolveConfigDataPromise(undefined);
        });
    };
    const getEfficiencyLabel = () => {
        return new Promise((resolveEfficiencyLabelPromise) => {
            if (resolvedEfficiencyLabelPromise === undefined) {
                i18Service.setLocale(localeService.language).then(() => {
                    i18Service.registerCallback((messages) => {
                        var _a;
                        const label = (_a = messages === null || messages === void 0 ? void 0 : messages[localeService.language]) === null || _a === void 0 ? void 0 : _a['nemo.ui.efficiency-class'];
                        resolvedEfficiencyLabelPromise = label || null;
                        resolveEfficiencyLabelPromise(label);
                    });
                });
            }
            resolveEfficiencyLabelPromise(resolvedEfficiencyLabelPromise);
        });
    };
    const analyseRenderedFootnotes = (footnotesFromFefa) => __awaiter(void 0, void 0, void 0, function* () {
        if (footnotesFromFefa &&
            footnotesFromFefa.length > 0 &&
            !(0, EqualFootnotes_1.equalFootnotes)(footnotesFromFefa, lastFootnotesFromFefa)) {
            if (!lastFootnotesFromFefa.length) {
                lastFootnotesFromFefa = footnotesFromFefa;
            }
            const footnotesToBeDispatched = [];
            const configurationData = yield getConfigData().finally();
            for (const { Key, Text } of footnotesFromFefa) {
                const isEecDisclaimerFootnote = Key.includes("nemo-fn_eec-disclaimer");
                const isFinancingFootnote = Key.includes("nemo-fn_financing");
                if (Text.includes("{eec_placeholder}") && !isEecDisclaimerFootnote && !isFinancingFootnote) {
                    const replacer = new TextReplacmentUtility_1.TextReplacementUtility(configurationData, localeService);
                    const eecDisclaimerFootnote = replacer.getEecDisclaimerFootnote();
                    if (eecDisclaimerFootnote !== '') {
                        footnotesToBeDispatched.push({
                            Key,
                            Text: Text.replace("{eec_placeholder}", eecDisclaimerFootnote),
                        });
                    }
                }
                else if (Text.includes("{eec_placeholder_") &&
                    !isEecDisclaimerFootnote &&
                    !isFinancingFootnote) {
                    const extractValue = (0, Extract_1.extract)(Text);
                    yield (0, EmissionConsumption_1.getEmissionConsumption)(vueFormatterService, localeService, extractValue)
                        .then((result) => {
                        footnotesToBeDispatched.push({
                            Key,
                            Text: Text.replace(`${"{eec_placeholder_"}${extractValue}}`, result),
                        });
                    })
                        .catch((e) => {
                        console.error(e);
                    });
                }
                else if (isFinancingFootnote) {
                    const replacer = new TextReplacmentUtility_1.TextReplacementUtility(configurationData, localeService);
                    const financeFootnote = replacer.getFinanceFootnote();
                    if (financeFootnote !== '') {
                        footnotesToBeDispatched.push({
                            Key,
                            Text: financeFootnote,
                        });
                    }
                }
                else if (isEecDisclaimerFootnote) {
                    const hasEecScope = marketContextService.hasEnvScope('EEC_CLASS');
                    const efficiencyLabel = yield getEfficiencyLabel();
                    const replacer = new TextReplacmentUtility_1.TextReplacementUtility(configurationData, localeService);
                    const eecDisclaimerFootnote = replacer.getEecDisclaimerFootnote(hasEecScope, efficiencyLabel);
                    if (eecDisclaimerFootnote !== '') {
                        footnotesToBeDispatched.push({
                            Key,
                            Text: eecDisclaimerFootnote,
                        });
                    }
                }
            }
            dispatchFootnotes(footnotesToBeDispatched).catch((e) => {
                console.warn('dynamic-footnote-service', e);
            });
        }
    });
    const updateInternalFootnoteReference = (update) => {
        const updatedFootnoteList = lastFootnotesFromFefa.slice();
        for (const updatedFootnote of update) {
            const footnoteKey = updatedFootnoteList.findIndex((item) => item.Key === updatedFootnote.Key);
            if (footnoteKey !== -1) {
                updatedFootnoteList[footnoteKey].Text = updatedFootnote.Text;
            }
            else {
                updatedFootnoteList.push(updatedFootnote);
            }
        }
        lastFootnotesFromFefa = updatedFootnoteList;
    };
    const dispatchFootnotes = (footnotesToBeDispatched) => __awaiter(void 0, void 0, void 0, function* () {
        if (footnotesToBeDispatched.length > 0) {
            updateInternalFootnoteReference(footnotesToBeDispatched);
            yield footnoteService.isInitialized().then(() => {
                footnoteService.replaceFootNotes(footnotesToBeDispatched);
            });
        }
    });
    const handleConfigurationUpdate = () => __awaiter(void 0, void 0, void 0, function* () {
        const eecFtn = lastFootnotesFromFefa.filter((ftn) => ftn.Key === "nemo-fn_eec-disclaimer");
        const isEecFtnRendered = eecFtn.length > 0;
        const financingFtn = lastFootnotesFromFefa.filter((ftn) => ftn.Key === "nemo-fn_financing");
        const isFinancingFtnRendered = financingFtn.length > 0;
        const footnoteUpdates = [];
        if (isEecFtnRendered) {
            footnoteUpdates.push({
                Key: "nemo-fn_eec-disclaimer",
                Text: '',
            });
        }
        if (isFinancingFtnRendered) {
            footnoteUpdates.push({
                Key: "nemo-fn_financing",
                Text: '',
            });
        }
        if (footnoteUpdates.length > 0) {
            yield analyseRenderedFootnotes(footnoteUpdates);
        }
    });
    document.addEventListener('configurationUpdate', handleConfigurationUpdate);
    return {
        create: () => {
            return {
                featureService: {
                    analyseRenderedFootnotes,
                },
            };
        },
    };
};
exports.DynamicFootnoteServiceV1Implementation = DynamicFootnoteServiceV1Implementation;
//# sourceMappingURL=dynamic-footnote-service-v1.js.map